export function getValidFillColor(color) {
  switch (color.toLowerCase()) {
    case 'white':
      return 'var(--lds-color-white)';
    case 'black':
      return 'var(--lds-color-black)';
    case 'red':
      return 'var(--lds-color-lilly)';
    default:
      // eslint-disable-next-line no-console
      console.warning(`
        Lilly Logo getValidFillColor processed an invalid color value of "${color}".
        The Lilly Logo can only be presented as pure "black", pure "white" or Lilly's "red" brand color.
        Invalid logo color parameters will result in a default to Lilly Red.
      `);
      return 'var(--lds-color-lilly)';
  }
}

export function getValidSizeClass(size) {
  const sizeValue = size.toLowerCase();
  switch (sizeValue) {
    case 'xs':
    case 'sm':
    case 'md':
    case 'lg':
    case 'xl':
    case 'fit':
      return `lilly-logo-${sizeValue}`;
    default:
      // eslint-disable-next-line no-console
      console.warning(`
        Lilly Logo getValidSizeClass processed an invalid size value of "${size}".
        The size value must be one of "xs", "sm", "md", "lg", "xl" or "fit".
        Invalid size parameters will result in a default to "lg" size.
      `);
      return 'lilly-logo-lg';
  }
}
